/* ============================================================
   X-SECTIONS — reusable sections pack JS (vanilla, add-only)
   Video banner autoplay · before/after slider · gallery
   lightbox · collapsible rows. All via data attributes.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1. Video banner: reliable autoplay ---------- */
  document.querySelectorAll('[data-video-banner] video').forEach(function (video) {
    if (video.hasAttribute('autoplay')) {
      // Browsers only allow autoplay when muted — enforce it.
      video.muted = true;
      var play = video.play();
      if (play && play.catch) play.catch(function () { /* stay paused, show poster */ });
    }
  });

  /* ---------- 2. Before / after slider ---------- */
  document.querySelectorAll('[data-before-after]').forEach(function (wrap) {
    var range = wrap.querySelector('[data-ba-range]');
    if (!range) return;
    var update = function () {
      wrap.style.setProperty('--ba-pos', range.value + '%');
    };
    range.addEventListener('input', update);
    update();
  });

  /* ---------- 3. Image gallery lightbox ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-item]'));
    var lightbox = gallery.querySelector('[data-gallery-lightbox]');
    if (!items.length || !lightbox) return;
    var img = lightbox.querySelector('[data-lightbox-img]');
    var caption = lightbox.querySelector('[data-lightbox-caption]');
    var current = 0;
    var lastFocus = null;

    var show = function (i) {
      current = (i + items.length) % items.length;
      var btn = items[current];
      img.src = btn.getAttribute('data-full');
      img.alt = btn.getAttribute('data-alt') || '';
      var cap = btn.getAttribute('data-caption') || '';
      caption.textContent = cap;
      caption.hidden = !cap;
    };
    var open = function (i) {
      lastFocus = document.activeElement;
      show(i);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      lightbox.querySelector('[data-lightbox-close]').focus();
    };
    var close = function () {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    items.forEach(function (btn, i) {
      btn.addEventListener('click', function () { open(i); });
    });
    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', close);
    lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', function (e) {
      e.stopPropagation(); show(current - 1);
    });
    lightbox.querySelector('[data-lightbox-next]').addEventListener('click', function (e) {
      e.stopPropagation(); show(current + 1);
    });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });
    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  });

  /* ---------- 7. Collapsible rows ---------- */
  document.querySelectorAll('[data-collapsible]').forEach(function (root) {
    root.querySelectorAll('[data-collapsible-toggle]').forEach(function (btn) {
      var body = btn.parentElement.querySelector('[data-collapsible-body]');
      if (!body) return;
      var setOpen = function (open) {
        btn.setAttribute('aria-expanded', String(open));
        if (open) {
          body.style.maxHeight = body.scrollHeight + 'px';
        } else {
          body.style.maxHeight = '0px';
        }
      };
      // Honor server-rendered initial state
      if (btn.getAttribute('aria-expanded') === 'true') {
        requestAnimationFrame(function () { setOpen(true); });
      }
      btn.addEventListener('click', function () {
        setOpen(btn.getAttribute('aria-expanded') !== 'true');
      });
    });
  });
})();
